import "./Footer.css";

const Footer=()=>{

    return (
        <>
           <footer className='footer footer-container'>
           <h4 className="mt-3">Made by Amlan</h4>
           </footer>  
        </>
    )
}


export { Footer };